import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Container } from '../containers/Container';
import { MuiIconButton } from '../../mui/MuiIconButton';
import { Webchat } from '../../webchat';
import { styles } from './styles.js';
import GuardianLogo from '../../../assets/images/guardian-logo.svg';
import LifeMadeBetter from '../../../assets/images/life-made-better.svg';
import ScottishFriendlyLogo from '../../../assets/images/scottish-friendly-logo.svg';
import PhoneIcon from '../../../assets/images/icons/phone-icon.svg';
import MailIcon from '../../../assets/images/icons/mail-icon.svg';
import ChatIcon from '../../../assets/images/icons/chat-icon.svg';
import LinkedInIcon from '../../../assets/images/icons/linkedin-icon.svg';
import LoaderImg from '../../../assets/images/file-loader.svg';

const Footer = ({ classes }) => {
  const { t } = useTranslation();
  return (
    <Box className={classes.root}>
      <Box className={classes.footer}>
        <Container classes={{ root: classes.container }}>
          <img
            src={GuardianLogo}
            width="240"
            height="47"
            alt={t('footerSubFooter.companyName')}
            data-testid="imgGuardian"
          />
          <Box className={classes.footerLinks} id="need-help">
            <Typography
              variant="body2"
              component="p"
              color="primary"
              data-testid="lblNeedHelp"
            >
              {t('footer.needHelp')}
            </Typography>
            <MuiIconButton
              label={t('footer.telephone')}
              icon={PhoneIcon}
              classes={{ root: classes.button, startIcon: classes.buttonIcon }}
              buttonProps={{
                size: 'medium',
                component: 'a',
                href: `tel:${t('footer.telephone').replace(/ /g, '')}`,
                'data-testid': 'lnkTelephone',
              }}
              data-testid="lnkTelephone"
            />
            <MuiIconButton
              label={t('footer.email')}
              icon={MailIcon}
              classes={{ root: classes.button, startIcon: classes.buttonIcon }}
              buttonProps={{
                size: 'medium',
                component: 'a',
                href: `mailto:${t('footer.email')}`,
                'data-testid': 'lnkEmail',
              }}
              data-testid="lnkEmail"
            />
            <Webchat>
              {({ onClick, loading, disabled }) => (
                <MuiIconButton
                  label={t('footer.webchat')}
                  icon={loading ? LoaderImg : ChatIcon}
                  classes={{
                    root: classes.button,
                    startIcon: classes.buttonIcon,
                  }}
                  buttonProps={{
                    disabled,
                    size: 'medium',
                    'data-testid': 'lnkWebChat',
                    onClick,
                  }}
                />
              )}
            </Webchat>
            <MuiIconButton
              label={t('footer.linkedIn')}
              icon={LinkedInIcon}
              classes={{
                root: classes.button,
                startIcon: classes.buttonIconLinkedIn,
              }}
              buttonProps={{
                size: 'medium',
                component: 'a',
                href: t('footer.linkedInUrl'),
                target: '_blank',
                'data-testid': 'lnkLinkedIn',
              }}
              data-testid="lnkLinkedIn"
            />
          </Box>
        </Container>
      </Box>
      <Box className={classes.subFooter}>
        <Container classes={{ root: classes.container }}>
          <img
            src={ScottishFriendlyLogo}
            className={classes.subFooterLogo}
            alt={t('footerSubFooter.logo')}
            data-testid="imgScottishFriendly"
          />
          <Box className={classes.subFooterText}>
            <Typography
              variant="body1"
              component="p"
              data-testid="lblGuardianAppointed"
              className={classes.introText}
            >
              {t('footerSubFooter.introText')}
            </Typography>
            <Typography
              variant="caption"
              component="p"
              data-testid="lblCopyRight"
            >
              {`© ${new Date().getFullYear()} ${t(
                'footerSubFooter.companyName'
              )}`}
            </Typography>
            <Typography
              variant="caption"
              component="p"
              className={classes.captionSmall}
              data-testid="lblGuardianAppointedAuthPru"
            >
              {t('footerSubFooter.regulation')} {t('footerSubFooter.office')}
            </Typography>
          </Box>
          <img src={LifeMadeBetter} data-testid="imgLifeMadeBetter" />
        </Container>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(Footer);
